import { Navigate, Outlet } from "react-router-dom";
import { getCurrentUser } from "./services/authServices";

export default function ProtectedRoutes() {
  const user = getCurrentUser()
  return user ? <Outlet /> : <Navigate to="/login" />;
}